import { render, staticRenderFns } from "./EventsBlock.vue?vue&type=template&id=8bdc9708&scoped=true&"
import script from "./EventsBlock.vue?vue&type=script&lang=js&"
export * from "./EventsBlock.vue?vue&type=script&lang=js&"
import style0 from "./EventsBlock.vue?vue&type=style&index=0&id=8bdc9708&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdc9708",
  null
  
)

export default component.exports